<div class="card-body form-grid">
  <div class="form-item">
    <label>Pricing</label>
    <div *ngIf="loading" class="mapping-box">Fetching pricing...</div>
    <div *ngIf="!loading && pricingError" class="mapping-box text-danger">
      {{ pricingError }}
    </div>
    <div *ngIf="!loading && pricing" class="mapping-box">
      <div class="form-item">
        <label>Hourly Cost</label>
        <input
          class="form-control"
          [ngModel]="pricing.hourly_cost_usd + ' ' + pricing.currency"
          disabled
        />
      </div>
      <div class="form-item">
        <label>Monthly Cost</label>
        <input
          class="form-control"
          [ngModel]="pricing.monthly_cost_usd + ' ' + pricing.currency"
          disabled
        />
      </div>
    </div>

    <div *ngIf="saveSuccessMessage" class="alert alert-success save-success-message mt-2 mb-0">
      <div>{{ saveSuccessMessage }}</div>
    </div>
    <div *ngIf="saveError" class="alert alert-danger save-error-message mt-2 mb-0">
      {{ saveError }}
    </div>

    <div class="step-footer mt-2">
      <button
        class="btn btn-primary"
        [disabled]="loading || saving || !pricing || !!pricingError"
        (click)="saveRequest()"
      >
        {{ saving ? "Saving..." : "Request Instance" }}
      </button>
    </div>
  </div>
</div>
